<template>
  <form
    @submit.prevent="saveAction"
    class="main-modal main-form main-modal_w698"
  >
    <div class="main-modal__title main-modal__title_mb32">
      <p>Zeitplan hinzufügen</p>
    </div>

    <div class="main-form__box">
      <Select2
        v-validate="'required'"
        data-vv-as="field"
        name="services"
        :options="services"
        :settings="selectSettingServices"
        v-model="schedule.service_id"
        class="select2-container_w100"
        @change="changeService"
      />
    </div>
    <div class="main-form__box" v-if="!schedule.date">
      <div class="schedule-weeks">
        <p class="schedule-weeks__title" v-text="$t('schedule.weekDays')"></p>

        <div class="schedule-weeks__btns">
          <div v-for="item of weekOptions" :key="item.key">
            <span
              @click="toSchedule(item.key)"
              :class="{
                'schedule-week_active': inWeekDays(item.key),
              }"
              v-text="item.text"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="main-form__box main-form__box_flex main-form__box_between">
      <div class="main-form__box_30">
        <label class="main-form__label">Preis pro Stunde:</label>

        <el-select
          v-model="schedule.time_base_price.from"
          :placeholder="$t('forms.select')"
          class="schedule-period__select mb-12"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="schedule.time_base_price.to"
          :placeholder="$t('forms.select')"
          class="schedule-period__select"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="main-form__box_30">
        <label class="main-form__label">Aufpreis 1:</label>

        <el-select
          v-model="schedule.time_extra_price_1.from"
          :placeholder="$t('forms.select')"
          class="schedule-period__select mb-12"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="schedule.time_extra_price_1.to"
          :placeholder="$t('forms.select')"
          class="schedule-period__select"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="main-form__box_30">
        <label class="main-form__label">Aufpreis 2:</label>

        <el-select
          v-model="schedule.time_extra_price_2.from"
          :placeholder="$t('forms.select')"
          class="schedule-period__select mb-12"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="schedule.time_extra_price_2.to"
          :placeholder="$t('forms.select')"
          class="schedule-period__select"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{ $t("global.cancel") }}
      </span>
      <button
        type="submit"
        :class="{
          disabled: !checkIsValid,
        }"
        :disabled="!checkIsValid"
        class="main-button main-button_success"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    name: 'schedule-modal',
    props: {
        serviceId: {
            required: true,
        },
    },
    computed: {
        checkIsValid() {
            if (this.schedule.time_base_price.from === null) return false
            if (this.schedule.time_base_price.to === null) return false

            return this.schedule.days.length !== 0
        },
        ...mapGetters({
            schedule: 'clientSchedule',
            services: 'servicesGetters',
            scheduleOfficeId: 'scheduleOfficeId',
        }),
    },
    data() {
        return {
            timeOptions: [
                { value: '00:00', label: '00:00' },
                { value: '01:00', label: '01:00' },
                { value: '02:00', label: '02:00' },
                { value: '03:00', label: '03:00' },
                { value: '04:00', label: '04:00' },
                { value: '05:00', label: '05:00' },
                { value: '06:00', label: '06:00' },
                { value: '07:00', label: '07:00' },
                { value: '08:00', label: '08:00' },
                { value: '09:00', label: '09:00' },
                { value: '10:00', label: '10:00' },
                { value: '11:00', label: '11:00' },
                { value: '12:00', label: '12:00' },
                { value: '13:00', label: '13:00' },
                { value: '14:00', label: '14:00' },
                { value: '15:00', label: '15:00' },
                { value: '16:00', label: '16:00' },
                { value: '17:00', label: '17:00' },
                { value: '18:00', label: '18:00' },
                { value: '19:00', label: '19:00' },
                { value: '20:00', label: '20:00' },
                { value: '21:00', label: '21:00' },
                { value: '22:00', label: '22:00' },
                { value: '23:00', label: '23:00' },
            ],
            weekOptions: [
                { key: 1, text: 'Mo' },
                { key: 2, text: 'Di' },
                { key: 3, text: 'Mi' },
                { key: 4, text: 'Do' },
                { key: 5, text: 'Fr' },
                { key: 6, text: 'Sa' },
                { key: 7, text: 'So' },
            ],
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
        }
    },
    methods: {
        ...mapActions({
            addClientSchedule: 'addClientSchedule',
            addClientScheduleByDay: 'addClientScheduleByDay',
            fetchClientScheduleById: 'fetchClientScheduleById',
            fetchClientSchedule: 'fetchClientSchedule',
        }),
        ...mapMutations({
            closeClientScheduleModal: 'closeClientScheduleModal',
            clearSchedule: 'clearSchedule',
        }),
        changeService() {},
        inWeekDays(id) {
            return this.schedule.days.lastIndexOf(id) !== -1
        },
        toSchedule(id) {
            const index = this.schedule.days.lastIndexOf(id)
            if (index === -1) {
                this.schedule.days.push(id)
                return
            }

            this.schedule.days.splice(index, 1)
        },
        prepareForm() {
            const form = {
                ...this.schedule,
            }

            form.service_id = this.schedule.service_id
            form.office_id = this.scheduleOfficeId

            if (!form.time_extra_price_1.from) delete form.time_extra_price_1
            if (!form.time_extra_price_2.from) delete form.time_extra_price_2

            return form
        },
        async doAction() {
            const form = this.prepareForm()
            return this.schedule.date
                ? await this.addClientScheduleByDay(form)
                : await this.addClientSchedule(form)
        },
        async saveAction() {
            const isOkey = await this.doAction()
            await this.fetchClientSchedule()
            await this.fetchClientScheduleById()
            if (!isOkey) return

            this.closeClientScheduleModal()
            this.clearSchedule()
        },
    },
    beforeDestroy() {
        this.clearSchedule()
    },
}
</script>
